import { render, staticRenderFns } from "./Distribuidores.vue?vue&type=template&id=05b048d2&scoped=true&"
import script from "./Distribuidores.vue?vue&type=script&lang=js&"
export * from "./Distribuidores.vue?vue&type=script&lang=js&"
import style0 from "./Distribuidores.vue?vue&type=style&index=0&id=05b048d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b048d2",
  null
  
)

export default component.exports